import { styled } from "@mui/material";

interface CardProps {
	padding?: boolean;
}

/**
 * @deprecated Use Card from MUI instead
 */
const Card = styled("div", {
	shouldForwardProp: (prop) => prop !== "padding",
})<CardProps>`
	background-color: ${({ theme }) => theme.palette.background.paper};
	border-radius: 6px;
	border: 1px solid ${({ theme }) => theme.palette.divider};
	padding: ${({ padding = true }) => (padding ? "16px" : null)};
`;

export default Card;
